import angular from 'angular';

import SwitchComponent from './switch.cmpt';

export default angular
    .module('application.component.switch', [])
    .component(SwitchComponent.selector, SwitchComponent);



// WEBPACK FOOTER //
// ./src/application/component/switch/index.js